/**
 * 
 * @returns {string} GraphQL Query
 */
export function getCurrentCguQuery() {
    return `CGUCurrentQuery {
        id
    }`;
}

/**
 * 
 * @returns {string} GraphQL Query
 */
 export function getCurrentCguAndClientLastTermQuery($authId) {
    return `CGUCurrentQuery {
        id
        clientLastTerm(auth0Id: "${$authId}") {
            id
        }
    }`;
}

/**
 * 
 * @returns {string} GraphQL Query
 */
 export function getCurrentDocumentQuery() {
    return `CGUCurrentDocumentQuery {
        fileContent
    }`;
}